import React from 'react'
import { Link } from 'react-router-dom'

import { pricingData } from '../data/startup'
import {FiArrowRightCircle} from '../assets/icons/vander'

export default function PricingTwo() {
  return (
    <div className="row justify-content-center">
        <div className="col-lg-10 col-12">
            <div className="row">
                {pricingData.map((item,index)=>{
                    let Icon = item.icon
                    return(
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="card pricing-plan border-0 shadow position-relative overflow-hidden rounded">
                                <div className="plan-detail position-relative overflow-hidden p-4 border-bottom">
                                    <h4 className="title">{item.title}</h4>
                                    <div className="d-flex">
                                        <span className="h5 mb-0 mt-2">$</span>
                                        <span className="price display-4 mb-0">{item.value}</span>
                                        <span className="h4 align-self-end mb-0">/mo</span>
                                    </div>
                                    <i className="big-icon"><Icon/></i>
                                </div>

                                <div className="content p-4">
                                    <ul className="list-unstyled ps-0">
                                        {item.feature.map((el,index)=>{
                                            return(
                                                <li className="feature-list h6 mb-1" key={index}><i className="text-success me-3"><FiArrowRightCircle/></i>{el}</li>
                                            )
                                        })}
                                    </ul>

                                    <div className="d-grid">
                                        <Link to="#" className="btn btn-primary mt-4">{item.btnText}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
  )
}
